<app-detail-list-template
    [Editing]="true"
    [Inline]="true"
    [Data]="ListTemplateData$ | async"
></app-detail-list-template>
